import * as React from 'react';
import Heading from '~/UI/Heading';

import { CheckboxRow } from './CheckboxRow';
import styles from './styles.less';
import { TextAreaRow } from './TextAreaRow';

export interface AnnexForm4Values {
	readonly introduction: string;
	readonly marketingAuthorizationHolder: boolean;
	readonly representativeOfMarketingAuthorizationHolder: boolean;
	readonly signedName: string;
}

export const AnnexForm4: React.FunctionComponent<
	React.PropsWithChildren<{
		disabled: boolean;
		values: AnnexForm4Values;
		onChange(values: AnnexForm4Values): void;
	}>
> = ({ disabled, values, onChange }) => {
	return (
		<div className={styles.profileSection}>
			<Heading level={2}>Export Annex 4</Heading>

			<TextAreaRow
				disabled={disabled}
				value={values.introduction}
				onChange={(value) => {
					onChange({ ...values, introduction: value });
				}}
			>
				Introduction
			</TextAreaRow>

			<CheckboxRow
				checked={values.marketingAuthorizationHolder}
				disabled={disabled}
				onChange={(checked) => {
					onChange({ ...values, marketingAuthorizationHolder: checked });
				}}
			>
				Marketing Authorization Holder
			</CheckboxRow>

			<CheckboxRow
				checked={values.representativeOfMarketingAuthorizationHolder}
				disabled={disabled}
				onChange={(checked) => {
					onChange({
						...values,
						representativeOfMarketingAuthorizationHolder: checked,
					});
				}}
			>
				Representative Of Marketing Authorization Holder
			</CheckboxRow>

			<TextAreaRow
				disabled={disabled}
				value={values.signedName}
				onChange={(value) => {
					onChange({ ...values, signedName: value });
				}}
			>
				Signed Name
			</TextAreaRow>
		</div>
	);
};

AnnexForm4.displayName = 'RoMaxPrice.UserSettings.AnnexForm4';
